import { render, staticRenderFns } from "./LinkDetailComp.vue?vue&type=template&id=64bdc2e0&"
import script from "./LinkDetailComp.vue?vue&type=script&lang=js&"
export * from "./LinkDetailComp.vue?vue&type=script&lang=js&"
import style0 from "./LinkDetailComp.vue?vue&type=style&index=0&id=64bdc2e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports